import React from 'react';
import PropTypes from 'prop-types';
import css from './SurveyDate.css'

export default class SurveyDate extends React.Component {

    render() {
         const { surveyDate, dateLabel } = this.props;
         const dataRoleProperty = `survey${dateLabel}Date`;
         return (
             <div className={css['survey-dates']}>
                 <label>{dateLabel}</label>
                 <div data-role={dataRoleProperty}>{surveyDate}</div>
             </div>
         );
    }
}

SurveyDate.propTypes = {
    surveyDate: PropTypes.string.isRequired,
    dateLabel: PropTypes.string.isRequired
};

